// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__Z4LKY","dragIcon":"SortableItem_dragIcon__28DVP","disabled":"SortableItem_disabled__2x6fQ"};